// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import Icon from './Icon';

type Props = {
  className?: string,
  children: React.Node,
  tagName?: string,
  title?: string,
};

export default function Info({
  children,
  className,
  tagName,
  title,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  return (
    <Base
      flex
      gap="xsmall"
      flexAlignItemsCenter
      className={className}
      tagName={tagName}
    >
      <Icon name="infoWire" theme="info" title={title || __('information')} />
      <Text tagName="span" color="light">
        {children}
      </Text>
    </Base>
  );
}
